<template>
  <div id="about_us" class="pb-0 pt-20">
    <div id="about_us_landing" class="flex w-screen justify-center items-center mt-24 mx-auto">
      <div class="max-w-4xl flex flex-col md:flex-row items-center justify-center h-auto px-16">
        <div class="z-1 flex w3 flex-col justify-center items-center">
          <h1 class="w-full text-4xl md:text-4xl text-white font-display text-center z-10">
            <span class="text-gray-5">Making software</span> that drives your business
          </h1>

          <div class="flex justify-center">
            <a href="#"
               class="block h-10 px-5 pt-2 pb-5 my-10 font-display border-yellow-primary bg-yellow-primary rounded-full"
            >
              See What We Do
            </a>
          </div>
        </div>
        <img src="@/assets/img/landing_photos/vr_set.jpg">
      </div>
    </div>

    <div class="flex flex-col items-center justify-center h-auto mx-auto w-screen mt-24">
      <h1 class="text-5xl text-center tracking-wider text-white font-bold mb-10">
        <span class="text-blackish-1">Look at</span> our work
      </h1>

      <div class="w-full flex flex-col flex-wrap lg:flex-row items-center justify-center mb-10">
        <CaseStudyListItem
          title="O2 Dobrá jazda"
          info="Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores
          numquam facere nulla exercitationem, non ducimus eligendi aspernatur ipsa adipis."
          image="ourWork1.jpg"
        />
        <CaseStudyListItem
          title="O2 Dobrá jazda"
          info="Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores
          numquam facere nulla exercitationem, non ducimus eligendi aspernatur ipsa adipis."
          image="ourWork1.jpg"
        />
        <CaseStudyListItem
          title="O2 Dobrá jazda"
          info="Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores
          numquam facere nulla exercitationem, non ducimus eligendi aspernatur ipsa adipis."
          image="ourWork1.jpg"
        />
      </div>

      <a href="#">
        <h1 class="text-center text-white font-text mt-10 mb-20 text-2xl"><a href="#">Show all case studies</a></h1>
      </a>
    </div>


    <div class="mt-24 flex flex-col justify-center items-center w-screen md:pb-20">
      <h1 class="text-2xl sm:text-4xl md:text-5xl text-white font-bold mb-16">
        What clients say <span class="text-blackish-1">about us</span>
      </h1>

      <div class="slideshow_container mb-32">
        <ClientReferenceListItem
          v-bind:id="0"
          v-bind:activeId="slideIndex"
          quote="I love you the more in that I believe you had liked me for my own sake and for nothing else"
          author="Ernest Hemingway"
          image="author1.jpg"
        />
        <ClientReferenceListItem
          v-bind:id="1"
          v-bind:activeId="slideIndex"
          quote="But man is not made for defeat. A man can be destroyed but not defeated."
          author="Ernest Hemingway"
          image="author1.jpg"
        />
        <ClientReferenceListItem
          v-bind:id="2"
          v-bind:activeId="slideIndex"
          quote="I have not failed. I've just found 10,000 ways that won't work."
          author="Ernest Hemingway"
          image="author1.jpg"
        />

        <a class="prev" v-on:click="slidesPrev()">&#10094;</a>
        <a class="next" v-on:click="slidesNext()">&#10095;</a>
      </div>
    </div>

    <div id="about_us_bottom_border" class="flex-row relative w-full z-2">
      <div id="top_overhang" class="w-screen absolute z-2">
        <img src="@/assets/img/top_curve.svg" alt="" class="w-full">
      </div>
    </div>
  </div>
</template>

<script>
  import CaseStudyListItem from './CaseStudyListItem';
  import ClientReferenceListItem from './ClientReferenceListItem';

  require('../../assets/css/index/about_us.css');

  const slideCount = 3;

  export default {
    name: 'AboutUs',
    components: {ClientReferenceListItem, CaseStudyListItem},
    data: function() {
      return {
        slideIndex: 0
      }
    },
    methods: {
      slidesPrev: function() {
        if(--this.slideIndex < 0)
          this.slideIndex += slideCount;
      },
      slidesNext: function() {
        if(++this.slideIndex >= slideCount)
          this.slideIndex -= slideCount;
      }
    },
    mounted: function() {
      setInterval(this.slidesNext, 6000);
    }
  }
</script>
